import { Type } from 'typebox';
import { Attachment } from '../reference/attachment.js';
import { createFallbackStringEnumCodec } from '../../utils/fallback-string-enum-codec.js';
export const EventActions = {
    Notify: 'Notify',
    AddToDaily: 'AddToDaily',
    ShareOnly: 'ShareOnly',
    Alert: 'Alert',
    StickyNote: 'StickyNote',
    Text: 'Text',
    unknown: 'unknown'
};
export const EventAction = Type.Union([
    Type.Literal(EventActions.Notify),
    Type.Literal(EventActions.AddToDaily),
    Type.Literal(EventActions.ShareOnly),
    Type.Literal(EventActions.Alert),
    Type.Literal(EventActions.StickyNote),
    Type.Literal(EventActions.Text),
    Type.Literal(EventActions.unknown)
]);
export const EventActionCodec = createFallbackStringEnumCodec(EventActions, EventActions.unknown);
export const EventScopes = {
    dependant: 'dependant',
    dependants: 'dependants',
    staff: 'staff',
    group: 'group',
    location: 'location',
    unknown: 'unknown'
};
export const EventScope = Type.Union([
    Type.Literal(EventScopes.dependant),
    Type.Literal(EventScopes.dependants),
    Type.Literal(EventScopes.staff),
    Type.Literal(EventScopes.group),
    Type.Literal(EventScopes.location),
    Type.Literal(EventScopes.unknown)
]);
export const EventScopeCodec = createFallbackStringEnumCodec(EventScopes, EventScopes.unknown);
export const EventTypes = {
    Broadcast: 'Broadcast',
    Note: 'Note',
    Activity: 'Activity',
    Milestone: 'Milestone',
    Incident: 'Incident',
    Enroll: 'Enroll',
    Documentation: 'Documentation',
    DailyReport: 'DailyReport',
    FamilyReport: 'FamilyReport',
    FamilyEvent: 'FamilyEvent',
    Media: 'Media',
    unknown: 'unknown'
};
export const EventType = Type.Union([
    Type.Literal(EventTypes.Broadcast),
    Type.Literal(EventTypes.Note),
    Type.Literal(EventTypes.Activity),
    Type.Literal(EventTypes.Milestone),
    Type.Literal(EventTypes.Incident),
    Type.Literal(EventTypes.Enroll),
    Type.Literal(EventTypes.Documentation),
    Type.Literal(EventTypes.DailyReport),
    Type.Literal(EventTypes.FamilyReport),
    Type.Literal(EventTypes.FamilyEvent),
    Type.Literal(EventTypes.Media),
    Type.Literal(EventTypes.unknown)
]);
export const EventTypeCodec = createFallbackStringEnumCodec(EventTypes, EventTypes.unknown);
export const EventCategories = {
    Default: 'Default',
    WeeklyPlan: 'WeeklyPlan',
    FamilyConference: 'FamilyConference',
    DevLearning: 'DevLearning',
    ReportCard: 'ReportCard',
    LearningGame: 'LearningGame',
    LetterHome: 'LetterHome',
    IndividualChildReport: 'IndividualChildReport',
    DevLearningReport: 'DevLearningReport',
    MightyMinutesActivity: 'MightyMinutesActivity',
    ITEActivity: 'ITEActivity',
    TeachingGuide: 'TeachingGuide',
    DistanceLearning: 'DistanceLearning',
    PhotoLibrary: 'PhotoLibrary',
    Recipe: 'Recipe',
    ChildrensBook: 'ChildrensBook',
    momovid: 'momovid',
    mmoinv: 'mmoinv',
    s2ctext: 's2ctext',
    s2cvid: 's2cvid',
    research: 'research',
    AlsPalsSong: 'AlsPalsSong',
    AlsPalsLetter: 'AlsPalsLetter',
    observation: 'observation',
    unknown: 'unknown'
};
export const EventCategory = Type.Union([
    Type.Literal(EventCategories.Default),
    Type.Literal(EventCategories.WeeklyPlan),
    Type.Literal(EventCategories.FamilyConference),
    Type.Literal(EventCategories.DevLearning),
    Type.Literal(EventCategories.ReportCard),
    Type.Literal(EventCategories.LearningGame),
    Type.Literal(EventCategories.LetterHome),
    Type.Literal(EventCategories.IndividualChildReport),
    Type.Literal(EventCategories.DevLearningReport),
    Type.Literal(EventCategories.MightyMinutesActivity),
    Type.Literal(EventCategories.ITEActivity),
    Type.Literal(EventCategories.TeachingGuide),
    Type.Literal(EventCategories.DistanceLearning),
    Type.Literal(EventCategories.PhotoLibrary),
    Type.Literal(EventCategories.Recipe),
    Type.Literal(EventCategories.ChildrensBook),
    Type.Literal(EventCategories.momovid),
    Type.Literal(EventCategories.mmoinv),
    Type.Literal(EventCategories.s2ctext),
    Type.Literal(EventCategories.s2cvid),
    Type.Literal(EventCategories.research),
    Type.Literal(EventCategories.AlsPalsSong),
    Type.Literal(EventCategories.AlsPalsLetter),
    Type.Literal(EventCategories.observation),
    Type.Literal(EventCategories.unknown)
]);
export const EventCategoryCodec = Type.Codec(Type.String())
    .Decode((value) => {
    switch (value) {
        case EventCategories.Default:
            return EventCategories.Default;
        case EventCategories.WeeklyPlan:
            return EventCategories.WeeklyPlan;
        case EventCategories.FamilyConference:
            return EventCategories.FamilyConference;
        case EventCategories.DevLearning:
            return EventCategories.DevLearning;
        case EventCategories.ReportCard:
            return EventCategories.ReportCard;
        case EventCategories.LearningGame:
            return EventCategories.LearningGame;
        case EventCategories.LetterHome:
            return EventCategories.LetterHome;
        case EventCategories.IndividualChildReport:
            return EventCategories.IndividualChildReport;
        case EventCategories.DevLearningReport:
            return EventCategories.DevLearningReport;
        case EventCategories.MightyMinutesActivity:
            return EventCategories.MightyMinutesActivity;
        case EventCategories.ITEActivity:
            return EventCategories.ITEActivity;
        case EventCategories.TeachingGuide:
            return EventCategories.TeachingGuide;
        case EventCategories.DistanceLearning:
            return EventCategories.DistanceLearning;
        case EventCategories.PhotoLibrary:
            return EventCategories.PhotoLibrary;
        case EventCategories.Recipe:
            return EventCategories.Recipe;
        case EventCategories.ChildrensBook:
            return EventCategories.ChildrensBook;
        case EventCategories.momovid:
            return EventCategories.momovid;
        case EventCategories.mmoinv:
            return EventCategories.mmoinv;
        case EventCategories.s2ctext:
            return EventCategories.s2ctext;
        case EventCategories.s2cvid:
            return EventCategories.s2cvid;
        case EventCategories.research:
            return EventCategories.research;
        case EventCategories.AlsPalsSong:
            return EventCategories.AlsPalsSong;
        case EventCategories.AlsPalsLetter:
            return EventCategories.AlsPalsLetter;
        case EventCategories.observation:
            return EventCategories.observation;
        default:
            return EventCategories.unknown;
    }
})
    .Encode((value) => value);
export const EventVisibilities = {
    Parent: 'p',
    Directors: 'd',
    Teachers: 't',
    unknown: 'unknown'
};
export const EventVisibility = Type.Union([
    Type.Literal(EventVisibilities.Parent),
    Type.Literal(EventVisibilities.Directors),
    Type.Literal(EventVisibilities.Teachers),
    Type.Literal(EventVisibilities.unknown)
]);
export const EventVisibilityCodec = createFallbackStringEnumCodec(EventVisibilities, EventVisibilities.unknown);
export const Event = Type.Object({
    key: Type.String({ minLength: 1 }),
    id: Type.String({ minLength: 1 }),
    version: Type.Optional(Type.Integer()),
    eventTime: Type.Number(),
    eventEta: Type.Optional(Type.Number()),
    createTimestamp: Type.Number(),
    updateTimestamp: Type.Number(),
    clientUpdateTimestamp: Type.Optional(Type.Number()),
    action: EventActionCodec,
    type: EventTypeCodec,
    category: Type.Optional(EventCategoryCodec),
    scope: EventScopeCodec,
    visibility: Type.Array(EventVisibilityCodec),
    inOutbox: Type.Boolean(),
    deleted: Type.Optional(Type.Boolean()),
    favorite: Type.Optional(Type.Boolean()),
    complete: Type.Boolean(),
    dismissed: Type.Boolean(),
    actor: Type.Optional(Type.String()),
    actorUid: Type.Optional(Type.String()),
    actorDisplay: Type.Optional(Type.String()),
    actorFullName: Type.Optional(Type.String()),
    members: Type.Array(Type.String({ minLength: 1 })),
    membersDisplay: Type.Optional(Type.Array(Type.String())),
    parentMemberDisplay: Type.Optional(Type.String()),
    group: Type.Optional(Type.String()),
    groupDisplay: Type.Optional(Type.String()),
    location: Type.String({ minLength: 1 }),
    locationDisplay: Type.Optional(Type.String()),
    attachments: Type.Array(Attachment),
    tz: Type.Optional(Type.String()),
    comment: Type.Optional(Type.String()),
    formattedComment: Type.Optional(Type.String()),
    htmlComment: Type.Optional(Type.String()),
    metadata: Type.Optional(Type.Unknown()),
    linkedEvent: Type.Optional(Type.String()),
    source: Type.Optional(Type.String()),
    labels: Type.Optional(Type.Array(Type.String())),
    unmodifiedLabels: Type.Optional(Type.Array(Type.String())),
    milestones: Type.Optional(Type.Array(Type.String())),
    cDomains: Type.Optional(Type.Array(Type.String())),
    cGoals: Type.Optional(Type.Array(Type.String())),
    cGoalLabels: Type.Optional(Type.Array(Type.String())),
    cLessonPlanningSubjectArea: Type.Optional(Type.String()),
    cLessonPlanningSubjectAreaLabel: Type.Optional(Type.String()),
    groupedEventId: Type.Optional(Type.String()),
    groupedEventIsPrimary: Type.Optional(Type.Boolean()),
    tsgId: Type.Optional(Type.Integer()),
    title: Type.Optional(Type.String()),
    recipients: Type.Optional(Type.Array(Type.String())),
    contentId: Type.Optional(Type.String()),
    drEntryId: Type.Optional(Type.String())
});
export function isDocumentationEventType(type) {
    return type === EventTypes.Documentation;
}
export function isDocumentationEvent(event) {
    return isDocumentationEventType(event.type);
}
